import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _BellLightCheck(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "m18 13 1.183 1.971c.805 1.343 1.208 2.014.921 2.522-.287.507-1.07.507-2.636.507H5.932c-1.02 0-1.53 0-1.808-.233a1 1 0 0 1-.346-.611c-.056-.359.206-.796.73-1.67l.579-.964.03-.05a8 8 0 0 0 1.073-3.179l.006-.057.362-3.26A4.47 4.47 0 0 1 11 4h2.338A4.39 4.39 0 0 1 17.5 7M9.102 18.406c.171.744.548 1.402 1.072 1.87.524.47 1.166.724 1.826.724s1.302-.254 1.826-.723c.524-.47.9-1.127 1.072-1.871" }),
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "m9 12.5 3 2.5 7-7" })));
}
const BellLightCheck = forwardRef(_BellLightCheck);
export { BellLightCheck };
